import { render, staticRenderFns } from "./ProfitHeader.vue?vue&type=template&id=7f9aa343&scoped=true&"
import script from "./ProfitHeader.vue?vue&type=script&lang=ts&"
export * from "./ProfitHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitHeader.vue?vue&type=style&index=0&id=7f9aa343&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9aa343",
  null
  
)

export default component.exports